import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { unsubscribe } from '../api/unsubscribeService';

const UnsubscribePage: React.FC = () => {
  const { t }        = useTranslation();
  const [params]     = useSearchParams();
  const navigate     = useNavigate();
  const token        = params.get('token');

  type Status = 'idle' | 'working' | 'ok' | 'error';
  const [status, setStatus] = useState<Status>('idle');

  // --- handlers -----------------------------------------------------------
  const handleConfirm = async () => {
    if (!token) return setStatus('error');
    try {
      setStatus('working');
      await unsubscribe(token);
      setStatus('ok');
      setTimeout(() => navigate('/'), 2500);
    } catch {
      setStatus('error');
    }
  };

  const handleCancel = () => navigate('/');

  // --- UI -----------------------------------------------------------------
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white p-6 rounded shadow space-y-6 text-center">
        {status === 'idle' && (
          <>
            <h2 className="text-xl font-bold">{t('unsubscribe.title')}</h2>
            <p>{t('unsubscribe.message')}</p>

            <div className="space-x-4 mt-6">
              <button
                onClick={handleConfirm}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded"
              >
                {t('unsubscribe.confirm')}
              </button>
              <button
                onClick={handleCancel}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
              >
                {t('unsubscribe.cancel')}
              </button>
            </div>
          </>
        )}

        {status === 'working' && <p>{t('unsubscribe.processing')}</p>}

        {status === 'ok' && <p>{t('unsubscribe.success')}</p>}

        {status === 'error' && (
          <p className="text-red-600">{t('unsubscribe.error')}</p>
        )}
      </div>
    </div>
  );
};

export default UnsubscribePage;
